import {Directive, HostListener} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
    selector: '[formControlName][ZipcodeMask]',
    standalone: false
})
export class ZipcodeMaskDirective {

  constructor(public ngcontrol: NgControl) {
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event: KeyboardEvent) {
    return this.omit_special_char(event);

  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event: KeyboardEvent) {
    return this.omit_special_char(event);
  }

  @HostListener('keypress', ['$event'])
  keypress(event: KeyboardEvent) {
    return this.omit_special_char(event);
  }
  @HostListener('input', ['$event'])
  @HostListener('paste', ['$event'])
  onInput(event: KeyboardEvent | ClipboardEvent): void {


    this.omit_special_char(event);
  }


  omit_special_char(event: KeyboardEvent | ClipboardEvent): boolean {
    console.log('zip --');
    const inputElement = event.target as HTMLInputElement;

    if (event instanceof ClipboardEvent) {
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData('text');
      const isValid = /^[A-Za-z0-9\s-]*$/.test(pastedText || '');
      if (!isValid) {
        event.preventDefault();
        return false;
      }
      return true;
    }
    else if (event instanceof KeyboardEvent) {
      const inputValue = inputElement.value;
      const hasLetters = /[A-Za-z]/.test(inputValue);
      
      const maxLength = hasLetters ? 7 : 10;

      if (inputValue.length >= maxLength && event.key !== 'Backspace' && !this.isTextSelected(inputElement)) {
        event.preventDefault();
        return false;
      }

      const key = event.key;
      const isValidKey = this.isAlphanumericKey(key) || key === 'Backspace' || key === ' ' || key === '-';

      if (!isValidKey) {
        event.preventDefault();
        return false;
      }

      if (this.isTextSelected(inputElement) && key !== 'Backspace') {
        const start = inputElement.selectionStart ?? 0;
        const end = inputElement.selectionEnd ?? 0;
        const newValue = inputValue.substring(0, start) + key + inputValue.substring(end);
        this.ngcontrol.control?.setValue(newValue);
        event.preventDefault();
      }

      if (key === 'Backspace') {
        const start = inputElement.selectionStart ?? 0;
        const end = inputElement.selectionEnd ?? 0;
        if (start !== end) {
          const newValue = inputValue.substring(0, start) + inputValue.substring(end);
          this.ngcontrol.control?.setValue(newValue);
          event.preventDefault();
        }
      }
    }

    return true;
  }

  private isAlphanumericKey(key: string): boolean {
    return /^[A-Za-z0-9]$/.test(key);
  }

  isTextSelected(inputElement: HTMLInputElement): boolean {
    return inputElement.selectionStart !== inputElement.selectionEnd;
  }

}


